







import {Component, Prop, Vue} from 'vue-property-decorator'

import {LatLon} from './models/LatLon'
import NMapChildren from './NMapChildren.vue'


@Component({
  components: {},
})
export default class NMapCircle extends NMapChildren {
  @Prop() public position!: LatLon

  @Prop() public icon!: string

  @Prop({default: 400}) public readonly radius!: number

  public init() {
    this.item = this.getNMap().providerInstance.addCircle(
      this.position,
      this.radius,
      this.$slots.default ? this.$slots.default[0].elm : null,
      this.$listeners && this.$listeners.click ? () => {
        this.$emit('click')
      } : ()=>{}
    )
  }
}
